import './css/style.css'
import Modal from './js/modal';
import eventBus from './js/event-bus';
import form from './js/form';

window.eventBus = eventBus;

let loading = true;

// TODO: colocar icone para os criterios de senha
// TODO: caso a senha não bata deixar o input com borda vermelha

const termos = () => {
  const modal = new Modal('modal-termos');
  const buttonTerms = document.getElementById('modal-termos-btn');


  buttonTerms.addEventListener('click', (event) => {
    event.preventDefault();

    modal.open();

    const buttonAgreeWithTerms = document.getElementById('button-concordo-termos');
    const checkTerms = document.getElementById('aceitar-termos');

    buttonAgreeWithTerms.addEventListener('click', () => {
      modal.close();

      window.eventBus.dispatchEvent('agreeTerms', { agree: true })
      checkTerms.checked = true;
    });
  });
}

const app = () => {
  // inicia o modal e acoes para o termos
  termos();

  // inicia as acoes do formulario
  form();

  if (loading) {
    loading = false;
    document.getElementById('main').classList.remove('loading');
    document.querySelector('.loader').classList.add('loader--hide');
  }
};

document.addEventListener('DOMContentLoaded', app);
